import { IAdminFlight, IFlightObject } from '../../../../../../store/admin/eventFlights/store';
import { IAdminEvent } from '../../../../../../store/admin/events/store';

type TGetEventFlightsObject = (event: IAdminEvent) => { [flightId: number]: IAdminFlight };

export const getEventFlightsObject: TGetEventFlightsObject = event =>
  event.flights.reduce(
    (accFlights: IFlightObject, flight: IAdminFlight) => ({
      ...accFlights,
      [flight.id]: flight
    }),
    {}
  );
